/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ActionsObservable, ofType, StateObservable } from "redux-observable";
import { switchMap } from "rxjs/operators";

import { IErrorModel, toErrorModel } from "../../models";
import { DataProvider } from "../../providers/DataProvider";
import { IAppState } from "../types";

import * as Actions from "./actions";
import * as Consts from "./consts";
import { IGetServerTimeAction } from "./types";

const getPerformanceTimeMs = () =>
  typeof performance !== "undefined" ? performance.now() : Date.now();

const getServerTimeEpic = (
  action$: ActionsObservable<IGetServerTimeAction>,
  _state: StateObservable<IAppState>,
) =>
  action$.pipe(
    ofType(Consts.GET_SERVER_TIME),
    switchMap(async () => {
      try {
        const info = await DataProvider.getInfo();
        const serverTimeMs = info.ServerDateTimeOffset
          ? new Date(info.ServerDateTimeOffset).getTime()
          : Number.NaN;

        if (Number.isNaN(serverTimeMs)) {
          throw new Error("Invalid server time");
        }

        return Actions.getServerTimeSuccess({
          apiVersion: info.ApiVersion,
          performanceTimeMs: getPerformanceTimeMs(),
          serverDateTimeOffset: info.ServerDateTimeOffset,
          serverTimeMs,
        });
      } catch (error) {
        return Actions.getServerTimeFailure(
          toErrorModel(error as IErrorModel, "Server time unavailable"),
        );
      }
    }),
  );

export const serverTimeEpics = [getServerTimeEpic];
